import { AbortableAPI, API, killNulls } from '../../utils';
import { GW_SERVICES_PREFIXES } from 'constants/gateway';
import { IParams } from 'http-requests/types';

import {
  CreateNewsFeedDTO,
  GetNewsCountResponseDTO,
  GetNewsResponseDTO,
  GetUnreadNewsResponseDTO,
  NewsDailyStatEntryDTO,
  NewsFeedDTO,
  NewsFeedFiltersDTO,
} from './dto';

const { C300, AI } = GW_SERVICES_PREFIXES;

/* Получение списка новостей */
export const GetNews = (options: {
  params: NewsFeedFiltersDTO;
  signal?: AbortSignal;
}): Promise<GetNewsResponseDTO> =>
  AbortableAPI.get(`/${C300}/models/news/`, {
    params: killNulls(options.params) as Record<string, unknown>,
    signal: options.signal,
  });

export const GetActualEvents = (options: {
  params: NewsFeedFiltersDTO;
  signal?: AbortSignal;
}) =>
  AbortableAPI.get(`/${C300}/models/news/actual_events/`, {
    params: killNulls(options.params) as Record<string, unknown>,
    signal: options.signal,
  });

export const GetNewsCount = (): Promise<GetNewsCountResponseDTO> =>
  AbortableAPI.get(`/${C300}/models/news/counts/`);

export const CreateNews = (
  data: CreateNewsFeedDTO,
  signal?: AbortSignal
): Promise<NewsFeedDTO> =>
  AbortableAPI.post(`/${C300}/models/news/`, {
    body: data as Record<string, unknown>,
    signal,
  });

export const GetNewsById = (
  id: string,
  signal?: AbortSignal
): Promise<NewsFeedDTO> =>
  AbortableAPI.get(`/${C300}/models/news/${id}/`, { signal });

export const UpdateNews = (
  id: string,
  data: NewsFeedDTO,
  signal?: AbortSignal
): Promise<NewsFeedDTO> =>
  AbortableAPI.patch(`/${C300}/models/news/${id}/`, {
    body: data as Record<string, unknown>,
    signal,
  });

export const GetUnreadNews = (
  signal?: AbortSignal
): Promise<GetUnreadNewsResponseDTO> =>
  AbortableAPI.get(`/${C300}/models/news_unread/`, {
    signal,
  });

export const MarkNewsAsRead = (id: string): Promise<void> =>
  AbortableAPI.get(`/${C300}/models/news_mark_read/${id}/`);

export const DeleteNews = (id: string, signal?: AbortSignal): Promise<void> =>
  AbortableAPI.delete(`/${C300}/models/news/${id}/`, { signal });

export const GetDailyFeedStatistics = (params: {
  news_id: string;
  date_from: string;
  date_till: string;
}): Promise<{ results: NewsDailyStatEntryDTO[] }> =>
  AbortableAPI.get(`/${C300}/models/news_daily_report/`, { params });

/** Отправить запрос на подключения ИИ-редактора */
export const CreateAiTicket = () =>
  API.gatewayPost(`/${C300}/models/news/ai/redactor_ticket/`);

/** Проверить статус сообщения на подключение ИИ-редактора */
export const CheckAiTicketStatus = (): Promise<{
  alert: string;
  text: string;
}> => API.get(`/${C300}/models/news/ai/status/`);

/** Сгенерировать текст по стилю, или исправить опечатки */
export const GenerateAiAnswer = (params: IParams) =>
  API.gatewayPost(`/${AI}/ml/llm/news-text-editor`, params);
